
import React from 'react';
import { Button, UiWrapper, View } from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Header from 'layout/components/Header/Header';

import InputLabel from 'components/InputLabel/InputLabel';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { useLoginAgent } from './hooks/useLoginAgent';

export const LoginAgent = () => {
	const { useHeader, useLoading } = UiWrapper.use();

	const { loading, email, password, setEmail, setPassword, doLogin } = useLoginAgent();

	useLoading(loading, { loadingMessage: loading });
	useHeader(<Header isB2B showButton={false} />, []);
	useInitialScrollToTop();

	return (
		<Wrapper title={'Login para agentes'}>
			<View loginAgentFormWrapperSt>
				<InputLabel
					value={email}
					onChange={(e) => {
						setEmail(e.target.value);
					}}
					label="Email"
				/>

				<InputLabel
					value={password}
					onChange={(e) => {
						setPassword(e.target.value);
					}}
					type="password"
					label="Contraseña"
				/>
			</View>
			<Button
				disabled={!email || !password}
				onClick={doLogin}
				style={{ marginTop: '40px', width: '140px' }}
			>
				Entrar
			</Button>
		</Wrapper>
	);
};
